var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-icon',{staticClass:"trigger",attrs:{"type":_vm.isActive ? 'menu-fold' : 'menu-unfold'},on:{"click":_vm.toggleClick}})}
var staticRenderFns = []

export { render, staticRenderFns }